import { render, staticRenderFns } from "./AppHeaderTabs.vue?vue&type=template&id=74aa7914&"
import script from "./AppHeaderTabs.vue?vue&type=script&lang=js&"
export * from "./AppHeaderTabs.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderTabs.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports